import NumberFormat from "react-number-format";
import { TextField } from "@mui/material";
import React from "react";
export const MyNumberField = (props) => {
  let error = props.helperText !== "" && props.helperText !== null && props.helperText !== undefined;
  return (
    <NumberFormat
      aria-label={props.label}
      size={props.size ? props.size : "medium"}
      customInput={TextField}
      name={props.name}
      format={props.format}
      mask="_"
      style={{ width: "100%", margin: "1rem 0", ...props.style }}
      helperText={props.helperText}
      error={error}
      value={props.value}
      decimalSeparator={props.decimalSeparator ? props.decimalSeparator : false}
      allowNegative={props.allowNegative ? props.allowNegative : false}
      variant="outlined"
      label={props.label}
      onChange={props.onChange}
      placeholder={props.placeholder}
      type={props.type}
      onKeyPress={props.onKeyPress}
    />
  );
};
